import { Card, CardContent } from '@blockit/ui/card';
import { Heading } from '@blockit/ui/heading';
import { Text } from '@blockit/ui/text';
import { PageContainer } from '@components/PageContainer';

export const ErrorFallback = () => {
  return (
    <PageContainer>
      <Card className='shadow-sm [--card-spacing:--spacing(8)]'>
        <CardContent className='flex flex-col gap-4 text-center'>
          <Heading order={1}>Oh no! Something went wrong.</Heading>
          <Text>Our team has been notified of the issue and is working to fix it as soon as possible.</Text>
        </CardContent>
      </Card>
    </PageContainer>
  );
};
